
/*===========*/
export const USER_EXISTS_SUCCESS = "USER_EXISTS_SUCCES";
export const USER_EXISTS_FAILURE = "USER_EXISTS_FAILUR";

export const USER_CREATE_SUCCESS = "USER_CREATE_SUCCES";
export const USER_CREATE_FAILURE = "USER_CREATE_FAILUR";

export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILURE = "GET_PROFILE_FAILURE";

export const GET_AGREEMENTS_SUCCESS = "GET_AGREEMENTS_SUCCESS";
export const GET_AGREEMENTS_FAILURE = "GET_AGREEMENTS_FAILURE";

export const CREATE_SAVE_AGREEMENT_SUCCESS = "CREATE_SAVE_AGREEMENT_SUCCESS";
export const CREATE_SAVE_AGREEMENT_FAILURE = "CREATE_SAVEA_GREEMENT_FAILURE";

export const CANCEL_AGREEMENT_SUCCESS = "CANCEL_AGREEMENT_SUCCESS";
export const CANCEL_AGREEMENT_FAILURE = "CANCEL_AGREEMENT_FAILURE";

export const GET_DASHBOARDS_DATA_SUCCESS = "GET_DASHBOARDS_DATA_SUCCESS";
export const GET_DASHBOARDS_DATA_FAILURE = "GET_DASHBOARDS_DATA_FAILURE";

export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAILURE = "GET_USER_INFO_FAILURE";

export const GET_EDIT_AGREEMENT_SUCCESS = "GET_EDIT_AGREEMENT_SUCCESS";
export const GET_EDIT_AGREEMENT_FAILURE = "GET_EDIT_AGREEMENT_FAILURE";

export const SEND_AGREEMENT_SUCCESS = "SEND_AGREEMENT_SUCCESS";
export const SEND_AGREEMENT_FAILURE = "SEND_AGREEMENT_FAILURE";

export const PREVIEW_AGREEMENT_SUCCESS = "PREVIEW_AGREEMENT_SUCCESS";
export const PREVIEW_AGREEMENT_FAILURE = "PREVIEW_AGREEMENT_FAILURE";

/*===========*/

